// should be unreachable and ensures all valid cases are handled
// if you're sneaky and do nasty typecasts it will make sure to punch you at runtime
export const assertExhaustive = (value: never): never => {
  throw new Error(`Unhandled component: ${(value as any)?.component}`);
};
